import { Box, Card, Skeleton } from '@factorialco/deprecated-design-system'

export const BenefitsCardBenefitSkeleton = () => {
  return (
    <Card>
      <Card.Eyebrow>
        {/* Avatar */}
        <Box width="full" flexDirection="row" justifyContent="spaceBetween">
          <Skeleton height="s40" width="s40" />
        </Box>
      </Card.Eyebrow>
      <Card.Content>
        <Box gap="s16" justifyContent="spaceBetween" height="full" width="full">
          <Box gap="s8" width="full">
            {/* Title */}
            <Skeleton height="s24" width="s120" />

            {/* Description */}
            <Box gap="s2" width="full">
              <Skeleton height="s24" width="full" />
              <Skeleton height="s24" width="full" />
            </Box>
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}
